export enum DYNAMIC_MODAL_GROUPS {
  QualityAlertToast = 'QualityAlertToast',
  CutsCheckAlertToast = 'CutsCheckAlertToast',
  ErrorToast = 'ErrorToast',
  Generic_Toast = 'Generic_Toast',
  Delete_Product = 'DeleteProduct',
  ApplyProductOption = 'ApplyProductOption',
  Loading_Toast = 'Loading_Toast',
  MinProductMissingToast = 'MinProductMissingToast',
  ProjectProductsNotUploaded = 'ProjectProductsNotUploaded',
  HappyCaseOrPhotokitCompleted = 'HappyCaseOrPhotokitCompleted',
  DuplicateToast = 'DuplicateToast',
}

export enum TOAST_TYPES {
  Success = 'success',
  Error = 'error',
  Info = 'info',
}
